<div class="graph-container">
  <!-- Header -->
  <div class="graph-header">
    <span class="graph-title">Graph</span>

    @if (hasChapters()) {
      <div class="view-toggle">
        <button
          type="button"
          class="view-toggle-btn"
          [class.view-btn-active]="viewMode() === 'scenes'"
          (click)="viewMode.set('scenes')"
        >Scenes</button>
        <button
          type="button"
          class="view-toggle-btn"
          [class.view-btn-active]="viewMode() === 'chapters'"
          (click)="viewMode.set('chapters')"
        >Chapters</button>
      </div>
    }

    @if (hasGraph()) {
      <button class="graph-fit-btn" (click)="fitGraph()">Fit</button>
    }

  </div>

  <!-- Graph content -->
  @if (scenesLoading()) {
    <div class="graph-loading">Loading scenes...</div>
  } @else if (!hasGraph()) {
    <div class="graph-empty">No scenes</div>
  }
  <div #cyContainer class="cy-container" [class.hidden]="scenesLoading() || !hasGraph()"></div>
</div>
